import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import EditorQuote from './components/EditorQuote';
import CategoryGrid from './components/CategoryGrid';
import FocusNarrative from './components/FocusNarrative';
import HotArticles from './components/HotArticles';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '黑料入口 - 51吃瓜黑料入口一二三 | 黑料入口官网与入口下载';
  }, []);

  return (
    <>
      <header>
        <Navbar />
      </header>

      <main>
        <HeroSection />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '黑料入口 - 51吃瓜黑料入口一二三 | 黑料入口官网与入口下载',
              description: '黑料入口站点承接51吃瓜黑料入口一二三、黑料入口官网及黑料入口下载需求，每日更新黑料网在线观看、吃瓜黑料在线等热门内容。',
              url: 'https://heiliaorukou.com/',
              isPartOf: {
                '@type': 'WebSite',
                name: '黑料入口',
                url: 'https://heiliaorukou.com/',
              },
            }),
          }}
        />

        <EditorQuote />
        <CategoryGrid />
        <FocusNarrative />
        <HotArticles />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}